// Mirrors the backend GetLatest* rule: only plain x.y.z versions are considered stable.
const STABLE_VERSION_REGEX = /^\d+\.\d+\.\d+$/;

export default function isStableVersionName(versionName) {
    return STABLE_VERSION_REGEX.test(versionName || "");
}
